export const MAP_STYLE = [
    { "featureType": "administrative", "elementType": "geometry", "stylers": [ { "visibility": "off" } ] },
    { "featureType": "administrative.neighborhood", "stylers": [ { "visibility": "off" } ] },
    { "featureType": "poi", "stylers": [ { "visibility": "off" } ] },
    { "featureType": "road", "stylers": [ { "visibility": "on" } ] },
    { "featureType": "road", "elementType": "labels.icon", "stylers": [ { "visibility": "off"  } ] },
    { "featureType": "transit", "stylers": [ { "visibility": "off" } ] },
    { stylers: [ { lightness: 0, }, { saturation: 0 } ] }
]

export const MAP_CONFIG: google.maps.MapOptions = {
    zoom: 16,
    disableDefaultUI: false,
    panControl: false,
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    clickableIcons: false
}